import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3qsnmrjb8c: FaireBrandEntity = {
  token: "b_3qsnmrjb8c",
  type: "brand",
  name: "Delaney and Blu",
  avatarUrl:
    "https://cdn.faire.com/fastly/9c1d7a19a4b6be7039acfb36f3e248ee9acede8a1bb6ebca8d30c0a334781bb5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2bc77c491287d51632b6a59616cb3436cc3e15936c54725e98c12c5654824cec.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9c1d7a19a4b6be7039acfb36f3e248ee9acede8a1bb6ebca8d30c0a334781bb5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2bc77c491287d51632b6a59616cb3436cc3e15936c54725e98c12c5654824cec.jpeg",
  location: "CINCINNATI, OH, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 11,
  isInsider: true,
  description:
    "Delaney and Blu is all about crafting bold and whimsical wearable art that's as unique as us individuals. Each piece is lovingly handmade by yours truly, Delaney, using polymer clay as my canvas to create lightweight statement jewelry that's all about bringing one confidence, the joy of color, and a whole lot of happiness.\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:31.339Z",
    importedBy: "entity-db-cli",
  },
};
